module.exports = __webpack_public_path__ + "img/access-ac.0d3bcf09.png";